document.addEventListener("turbolinks:load", function () {
    const enableImportAssignmentsButton = () => {
        const button = document.getElementById("importAssignments");
        if (!button || button.tagName.toLowerCase() === "a") return;

        const importUrl = button.dataset.importUrl;
        if (!importUrl) {
            button.disabled = false;
            return;
        }

        const link = document.createElement("a");
        link.href = importUrl;
        link.id = button.id;
        link.className = button.className;
        link.style.cssText = button.style.cssText;
        link.setAttribute("aria-label", button.getAttribute("aria-label") || "Import Assignments");
        link.textContent = button.textContent.trim();
        button.replaceWith(link);
    };

    const feedback = document.getElementById("assignment-resource-import-feedback");
    if (feedback) {
        const statusUrl = feedback.dataset.statusUrl;

        const refreshMyAssignmentsList = () => {
            if (typeof window.refreshAssignmentResourceList === "function") {
                window.refreshAssignmentResourceList();
            } else {
                window.location.reload();
            }
        };

        const updateFeedbackText = (data) => {
            const text = document.getElementById("assignment-resource-import-feedback-text");
            if (text) text.textContent = `Importing Past Assignments (${data.processed_count}/${data.total_count})`;
        };

        // Poll while an import is active, then refresh My Assignments so newly
        // created resources appear without requiring a manual page reload.
        const updateFeedback = () => {
            fetch(statusUrl, { headers: { "Accept": "application/json" } })
                .then(response => response.json())
                .then(data => {
                    const hasNewImportedAssignments = window.assignmentResourceNotifications
                        ?.notifyImportedAssignmentResources(data.assignment_resource_ids || []);
                    const refreshedMyAssignments = hasNewImportedAssignments &&
                        window.assignmentResourceNotifications?.myAssignmentsTabIsActive();

                    if (refreshedMyAssignments) {
                        refreshMyAssignmentsList();
                    }

                    if (!data.active) {
                        enableImportAssignmentsButton();
                        if (!refreshedMyAssignments) {
                            refreshMyAssignmentsList();
                        }
                        document.getElementById("assignment-resource-import-feedback")?.remove();
                        return;
                    }

                    updateFeedbackText(data);
                    window.setTimeout(updateFeedback, 3000);
                })
                .catch(() => window.setTimeout(updateFeedback, 5000));
        };

        window.setTimeout(updateFeedback, 3000);
    }

    const root = document.getElementById("assignment-resource-import");
    if (!root) return;

    const selected = new Map();
    // Map preserves insertion order, which is the order the backend imports in.
    const assignmentCheckboxes = Array.from(root.querySelectorAll(".assignment-resource-import__assignment-checkbox"));
    const groupCheckboxes = Array.from(root.querySelectorAll(".assignment-resource-import__course-checkbox, .assignment-resource-import__folder-checkbox"));
    const count = document.getElementById("assignment-resource-import-selected-count");
    const list = document.getElementById("assignment-resource-import-selected-list");
    const empty = document.getElementById("assignment-resource-import-selected-empty");
    const clear = document.getElementById("assignment-resource-import-clear");
    const submit = document.getElementById("assignment-resource-import-submit");
    const hiddenInputs = document.getElementById("assignment-resource-import-selected-inputs");
    const search = document.getElementById("assignment-resource-import-search");
    const form = document.getElementById("assignment-resource-import-form");

    const assignmentData = (checkbox) => ({
        id: checkbox.dataset.assignmentId,
        name: checkbox.dataset.assignmentName,
        courseName: checkbox.dataset.courseName,
        groupName: checkbox.dataset.groupName
    });

    const assignmentIdsFor = (checkbox) => (checkbox.dataset.assignmentIds || "")
        .split(",")
        .map(id => id.trim())
        .filter(Boolean);

    const checkboxForAssignment = (assignmentId) => root.querySelector(`.assignment-resource-import__assignment-checkbox[data-assignment-id="${assignmentId}"]`);

    const addAssignment = (assignmentId) => {
        const checkbox = checkboxForAssignment(assignmentId);
        if (!checkbox || selected.has(assignmentId)) return;

        checkbox.checked = true;
        selected.set(assignmentId, assignmentData(checkbox));
    };

    const removeAssignment = (assignmentId) => {
        const checkbox = checkboxForAssignment(assignmentId);
        if (checkbox) checkbox.checked = false;
        selected.delete(assignmentId);
    };

    const createHiddenInput = (assignmentId) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "assignment_ids[]";
        input.value = assignmentId;
        return input;
    };

    const createMeta = (text) => {
        const meta = document.createElement("div");
        meta.className = "assignment-resource-import__selected-meta";
        meta.textContent = text;
        return meta;
    };

    const createSelectedCard = (data, assignmentId) => {
        const card = document.createElement("div");
        card.className = "assignment-resource-import__selected-card";
        card.dataset.assignmentId = assignmentId;

        const copy = document.createElement("div");
        const title = document.createElement("div");
        title.className = "assignment-resource-import__selected-title";
        title.textContent = data.name;
        copy.appendChild(title);

        if (data.groupName) copy.appendChild(createMeta(data.groupName));
        copy.appendChild(createMeta(data.courseName));

        const remove = document.createElement("button");
        remove.type = "button";
        remove.className = "assignment-resource-import__remove";
        remove.setAttribute("aria-label", `Remove ${data.name}`);
        remove.textContent = "×";
        remove.addEventListener("click", () => {
            removeAssignment(assignmentId);
            updateUi();
        });

        card.appendChild(copy);
        card.appendChild(remove);
        return card;
    };

    const updateGroupCheckboxes = () => {
        groupCheckboxes.forEach(checkbox => {
            const ids = assignmentIdsFor(checkbox);
            const selectedCount = ids.filter(id => selected.has(id)).length;

            checkbox.checked = ids.length > 0 && selectedCount === ids.length;
            checkbox.indeterminate = selectedCount > 0 && selectedCount < ids.length;
        });
    };

    const renderSelected = () => {
        list.querySelectorAll(".assignment-resource-import__selected-card").forEach(card => card.remove());
        hiddenInputs.innerHTML = "";

        selected.forEach((data, assignmentId) => {
            hiddenInputs.appendChild(createHiddenInput(assignmentId));
            list.appendChild(createSelectedCard(data, assignmentId));
        });

        count.textContent = selected.size.toString();
        empty.classList.toggle("d-none", selected.size > 0);
        clear.classList.toggle("d-none", selected.size === 0);
        submit.disabled = selected.size === 0;
    };

    const updateUi = () => {
        updateGroupCheckboxes();
        renderSelected();
    };

    assignmentCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("click", event => event.stopPropagation());
        checkbox.addEventListener("change", () => {
            if (checkbox.checked) {
                addAssignment(checkbox.dataset.assignmentId);
            } else {
                removeAssignment(checkbox.dataset.assignmentId);
            }
            updateUi();
        });
    });

    groupCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("click", event => event.stopPropagation());
        checkbox.addEventListener("change", () => {
            assignmentIdsFor(checkbox).forEach(assignmentId => {
                if (checkbox.checked) {
                    addAssignment(assignmentId);
                } else {
                    removeAssignment(assignmentId);
                }
            });
            updateUi();
        });
    });

    clear.addEventListener("click", () => {
        selected.clear();
        assignmentCheckboxes.forEach(checkbox => checkbox.checked = false);
        updateUi();
    });

    form.addEventListener("submit", event => {
        if (selected.size === 0) {
            event.preventDefault();
            return;
        }

        submit.disabled = true;
    });

    search.addEventListener("input", () => {
        const query = search.value.trim().toLowerCase();
        root.querySelectorAll(".import-tree-row").forEach(row => {
            const matches = query.length === 0 || (row.dataset.importSearchText || "").includes(query);
            row.hidden = !matches;
            if (query.length > 0 && matches && row.tagName.toLowerCase() === "details") {
                row.open = true;
            }
        });
    });

    updateUi();
});
